import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router'
import propTypes from 'prop-types'
import map from 'lodash/map'

import Expert from '@components/Icon/Expert'
import ProjectsIcon from '@components/Icon/ProjectsIcon'
import SearchIcon from '@components/Icon/Search'
import ClientRecords from '@components/Icon/ClientRecords'
import ReportsIcon from '@components/Icon/Reports'
import onClickOutside from 'react-onclickoutside'
import './search.sass'

class Search extends Component {
  static propTypes = {
    history: propTypes.object,
    searchStore: propTypes.object
  }

  searchClick = (e, val) => {
    e.preventDefault()

    // When nothing selected and user hits Enter,
    // val.indexType will be empty, so we can just ignore the call
    if (!val.indexType) return

    const paths = {
      expert: 'expert',
      project: 'project',
      parent_account: 'client-search/parent-account',
      account: 'client-search/account',
      office: 'client-search/office',
      contract: 'contract',
      client: 'client-contact',
      invoice: val.projectId
        ? `project/${val.projectId}/invoice`
        : `contract/${val.contractId}/invoice`
    }

    this.props.history.push(`/${paths[val.indexType]}/${val.id}`)
    this.props.searchStore.clean()
  }

  renderIcon = ({ indexType }) => {
    switch (indexType) {
      case 'expert':
        return <Expert className='SearchIcon' />
      case 'client':
        return <Expert className='SearchIcon' />
      case 'project':
        return <ProjectsIcon className='SearchIcon' />
      case 'invoice':
        return <ReportsIcon className='SearchIcon' />
      default:
        return <ClientRecords gray className='SearchIcon' />
    }
  }

  renderMenuItem = (item, index) => {
    const className = `SearchItem ${
      index === this.props.searchStore.targetIndex ? 'SearchItem-active' : ''
    }`
    return (
      <div
        onMouseEnter={() => (this.props.searchStore.targetIndex = index)}
        className='fastNavSearchItem'
        onClick={e => this.searchClick(e, item)}
      >
        <div className={className}>
          <div className='SearchItemText'>
            <div>
              <div className='SearchItem-itemType'>{item.itemType}</div>
              {item.menuTitle}
            </div>
            <div>
              <span title='Expert code'>{item.menuSubTitle || '-'}</span>
            </div>
          </div>
          {this.renderIcon(item)}
        </div>
      </div>
    )
  }

  handleClickOutside = e => {
    const desktopScreenSize = 1091
    if (window.innerWidth > desktopScreenSize) {
      this.props.searchStore.clean()
    }
  }

  onKeyUp = e => {
    const ENTER = 13
    const KEY_DOWN = 40
    const KEY_UP = 38

    if ([ENTER, KEY_DOWN, KEY_UP].includes(e.keyCode)) e.preventDefault()

    switch (e.keyCode) {
      case KEY_DOWN:
        return this.props.searchStore.targetDown()
      case KEY_UP:
        return this.props.searchStore.targetUp()
      case ENTER:
        return this.searchClick(
          e,
          this.props.searchStore.results[this.props.searchStore.targetIndex]
        )
      default:
    }
  }

  render () {
    const store = this.props.searchStore

    const containerClassName = store.results.length
      ? 'search-panel__results-container'
      : 'search-panel__results-container search-panel__results-container--hidden'

    return (
      <div tabIndex={0} className='Search--container'>
        <input
          onKeyDown={this.onKeyUp}
          placeholder='Search anything...'
          className='search-panel__input'
          value={this.props.searchStore.query}
          onChange={e => this.props.searchStore.onChange(e.target.value)}
        />

        <div className='Search--SearchIcon'>
          <SearchIcon />
        </div>
        <div className={containerClassName}>
          {map(store.results, this.renderMenuItem)}
        </div>
      </div>
    )
  }
}

export default withRouter(
  inject('searchStore')(onClickOutside(observer(Search)))
)
